module.exports = __webpack_public_path__ + "static/media/instluminarias2.be6af0ca.jpg";